import { evaluate } from 'mathjs';

export default {
  liittymismaksu(rakennustyyppi, tehontarve, liittymisetaisyys) {
    let kaava = 'liittymisetaisyys * 240';
    if (rakennustyyppi === 'okt') {
      kaava = 'liittymisetaisyys * 135 + 430';
    }

    return evaluate(kaava, { liittymisetaisyys });
  },
  tehomaksu(rakennustyyppi, tehontarve) {
    if (rakennustyyppi === 'okt') {
      return 643.02;
    }

    const kategoriat = [
      {
        min: 0,
        max: 30,
        a: 61.9,
        b: 92.7,
      },
      {
        min: 31,
        max: 100,
        a: 462.2,
        b: 79.8,
      },
      {
        min: 101,
        max: 250,
        a: 1840.6,
        b: 66.1,
      },
      {
        min: 251,
        max: 700,
        a: 7945.7,
        b: 41.8,
      },
      {
        min: 701,
        max: 999999999,
        a: 9082.5,
        b: 40.2,
      },
    ];

    const kategoria = kategoriat.find(c => tehontarve >= c.min && tehontarve <= c.max);
    kategoria.teho = tehontarve;
    return evaluate('a + b * teho', kategoria);
  },
  energiamaksu(rakennustyyppi) {
    if (rakennustyyppi === 'okt') {
      return 81.67;
    }

    return 64.72;
  },
}
